import { BhAppointmentAttendanceLabel } from './bh-appointment-attendance-label.enum';

/**
 * Normalizes DW / UI `attendanceLabel` strings for comparison (trim, lower-case, collapse spaces).
 * Keep in sync with server BH appointment classification — single definition for portal + API.
 */
export function normalizeBhAppointmentAttendanceLabel(label: string): string {
  return label.trim().toLowerCase().replace(/\s+/g, ' ');
}

/** Source data sometimes uses casing/aliases different from {@link BhAppointmentAttendanceLabel.NotAttended}. */
const MISSED_OR_NO_SHOW_LABELS_NORMALIZED = new Set([
  normalizeBhAppointmentAttendanceLabel(BhAppointmentAttendanceLabel.NotAttended),
  'no show',
  'no-show',
  'noshow',
  'did not attend',
  'didnt attend',
]);

/**
 * True when the label indicates a missed / no-show style attendance (aligned with server docket + alerts).
 */
export function bhAppointmentAttendanceLabelIndicatesMissedOrNoShow(
  attendanceLabel: string | null | undefined
): boolean {
  const raw = (attendanceLabel ?? '').trim();
  if (!raw) {
    return false;
  }
  return MISSED_OR_NO_SHOW_LABELS_NORMALIZED.has(
    normalizeBhAppointmentAttendanceLabel(raw)
  );
}
